module.exports = __webpack_public_path__ + "static/media/mbl_parent_logo.e571b2fe.svg";